import React, { useContext } from "react";
import "./NavBar.css";
import logo from "../../container/image/logo.png";
import { NavLink, useLocation, useHistory } from "react-router-dom";
import Login from "../../user/Login/Login";
import MainContext from './../../context/mainContext';
import { userLogout } from "../../../service/userService";
import { Dropdown } from "react-bootstrap";


const Navbar = ({onShowDraw}) => {
    const { pathname } = useLocation();
    const history = useHistory();
    const context = useContext(MainContext)


    return (
        <React.Fragment>
            <nav
                className="rtl navbar position-relative navbar-expand-lg pr-2 pl-0 navbar-dark bg-dark"
                id="navbar"
            >
                <NavLink
                    to = "/" exact
                    className="navbar-brand py-0  "
                    style={{ height: "100%" }}
                >
                    <img src={logo} className="navbar_brand" alt=""/>
                </NavLink>
                <span style={{ fontSize: "1.3rem" }} className="d-lg-none mx-1 text-white">
                    |
                </span> 
                <button
                    onClick={onShowDraw}
                    style={{outline:'none'}}
                    className="navbar-toggler text-white "
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarNavDropdown"
                    aria-controls="navbarNavDropdown"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div
                    className="collapse navbar-collapse h-100"
                    id="navbarNavDropdown"
                >
                    <ul className="navbar-nav pl-2 mx-auto">
                        <li className="nav-item mr-2">
                            <NavLink to='/' exact className={pathname === '/' ? "nav-link active" : "nav-link"}>
                                <i className="fa fa-home mr-2"></i>
                                صفحه اصلی
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to='/who' className={pathname === '/job' ? "nav-link active" : "nav-link"}>
                                <i className="fa fa-id-card mr-2"></i>
                                کی خوبه ؟
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to='/where' className={pathname === '/edu' ? "nav-link active" : "nav-link"}>
                                <i className="fa  fa-map-marker mr-2"></i>
                                کجا خوبه ؟
                            </NavLink>
                        </li>

                        <li className="nav-item">
                            <NavLink to='/shop' className={pathname === '/shop' ? "nav-link active" : "nav-link"}>
                                <i className="fa fa-shopping-basket mr-2"></i>
                                فروشگاه
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to='/about' className={pathname === '/about' ? "nav-link active" : "nav-link"}>
                                <i className="fa fa-users mr-2"></i>
                                درباره ما
                            </NavLink>
                        </li>
                    </ul>
                </div>
                <span style={{ fontSize: "1.3rem" }} className="d-lg-none mx-1 text-white">
                    |
                </span> 
                <div className=" mr-auto user-info-nav text-lg-right">
                    {
                        !context.loggedIn ? 
                        <React.Fragment>
                            <span className="nav-icon ml-1 mr-lg-2"
                                onClick={context.showLogin}
                            >
                                <i className="fa fa-user-o"></i>
                                <span style={{fontSize:'.9rem', marginRight:'6px'}}>ورود</span>
                            </span>
                            <Login 
                                show={context.showLoginModal}
                                onCancel={context.hideLogin}
                            />
                        </React.Fragment>
                         : 
                        <span className="nav-icon rtl">
                            <Dropdown className="d-inline-block  navbar-dropdown">
                                <Dropdown.Toggle variant="" id="dropdown-basic">
                                    <span className="online-blinker "></span>
                                    <i className="fa fa-user-circle-o userNameIcon"></i>
                                    <span className="text-white userName ">
                                         {context.loggedIn && context.loggedIn.fullName} 
                                    </span>
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="py-1">
                                    <Dropdown.Item 
                                        onClick={() => history.push('/edituser')}
                                    >
                                        <span><i className="fa fa-user"></i>ویرایش اطلاعات</span>
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                        onClick={() => history.push('/shoppingcart')}
                                    >
                                        <span><i className="fa fa-shopping-cart"></i>سبد خرید</span>
                                        <span className="badge badge-success badge-pill ml-2">
                                            {
                                                context.shoppingCart.length
                                            }
                                        </span>
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                        onClick={() => history.push('/product-orders')}
                                    >
                                        <span><i className="fa fa-list"></i>سفارشات کالا</span>
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                        onClick={() => history.push('/orders')}
                                    >
                                        <span><i className="fa fa-list"></i>سفارشات خدمات</span>
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                        onClick={() => history.push('/wallet', 
                                            { wallet: context.loggedIn.wallet }
                                        )}
                                    >
                                        <span><i className="fa fa-shopping-bag"></i>
                                            <span style={{position:'relative', top:'2px'}}>کیف پول</span>
                                        </span>
                                    </Dropdown.Item>
                                    <Dropdown.Divider />
                                    <Dropdown.Item 
                                        onClick={() => {
                                            (async () => {
                                                try {
                                                    await userLogout();
                                                    localStorage.removeItem('token');
                                                    context.logout();
                                                } catch (error) {}
                                            })();
                                        }}
                                    >
                                    <span ><i className="fa fa-sign-out"></i> خروج </span>
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </span>
                    }
                     
                </div>
                <div className="shopping-cart-icon-layer">
                    <span className={`shopping-cart-icon 
                        ${(context.shoppingCart && context.shoppingCart.length && pathname !== '/shoppingcart') 
                            && 'shopping-cart-icon-fixed'}`}
                        onClick={() => history.push('/shoppingcart')}
                    >
                        <span className="text-white">
                            {context.shoppingCart ? context.shoppingCart.length : 0}
                        </span>
                        <i className="fa fa-shopping-cart " id="sh-icon"></i>
                    </span>
                </div>
            </nav>

        </React.Fragment>
    );
};

export default Navbar;
